import { render, staticRenderFns } from "./AccreditationDetailsLayout.vue?vue&type=template&id=71167fb8&scoped=true"
import script from "./AccreditationDetailsLayout.vue?vue&type=script&lang=js"
export * from "./AccreditationDetailsLayout.vue?vue&type=script&lang=js"
import style0 from "./AccreditationDetailsLayout.vue?vue&type=style&index=0&id=71167fb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71167fb8",
  null
  
)

export default component.exports